module.exports = __webpack_public_path__ + "img/goods12_5.37fbbc2f.jpg";